import { useState, useEffect, useCallback } from "react";
import { subirDatosSingle, bajarDatosSingle } from "./syncSupabase";
import BotonInstructivo from "./BotonInstructivo";
import BotonMapaProceso from "./BotonMapaProceso";
import { ModalGenerarOC } from "./ComprasUtils";
import { authHeader } from './supabase';

const STORAGE_KEY = "alqos_hs";

const tiposIncidente = {
  accidente:        { label: "🔴 Accidente",         color: "#e63946" },
  casi_accidente:   { label: "🟡 Casi accidente",    color: "#f59e0b" },
  incidente:        { label: "🔵 Incidente",          color: "#3b82f6" },
  condicion_insegura:{ label: "🟠 Condición insegura",color: "#f97316" },
  acto_inseguro:    { label: "⚠️ Acto inseguro",     color: "#eab308" },
};

const estadosHS = {
  abierto:          { label: "🔓 Abierto",           color: "#e63946" },
  en_investigacion: { label: "🔍 En investigación",  color: "#f59e0b" },
  cerrado:          { label: "✅ Cerrado",            color: "#22c55e" },
};

const areasPlanta = [
  "Impresión Offset","Pre Prensa","Corte y Troquelado","Terminaciones",
  "Control de Calidad","Depósito / Expedición","Administración",
  "Mantenimiento","Patio / Exterior","General"
];

const TABS_PRINCIPALES = ["registros","epp","permisos","matriz","indices","aria"];
const TABS_LABELS = {
  registros: "📋 Registros",
  epp:       "🦺 EPP",
  permisos:  "🔑 Permisos de Trabajo",
  matriz:    "📊 Matriz de Riesgos",
  indices:   "📈 Índices SRT",
  aria:      "🤖 ARIA",
};

const tiposEPP = [
  "Casco","Calzado de seguridad","Guantes","Lentes de seguridad",
  "Protector auditivo","Arnés","Ropa ignífuga","Máscara respiratoria",
  "Chaleco reflectivo","Pantalla facial"
];

const tiposPermiso = {
  altura:            { label: "🏗️ Trabajo en Altura",          color: "#f97316" },
  espacio_confinado: { label: "⚠️ Espacio Confinado",          color: "#e63946" },
  trabajo_en_caliente:{ label: "🔥 Trabajo en Caliente",       color: "#eab308" },
  bloqueo_etiquetado:{ label: "🔒 Bloqueo y Etiquetado",       color: "#3b82f6" },
  electrico:         { label: "⚡ Trabajo Eléctrico",          color: "#7B5BF2" },
};

const estadosPermiso = {
  pendiente:  { label: "⏳ Pendiente",   color: "#f59e0b" },
  aprobado:   { label: "✅ Aprobado",    color: "#22c55e" },
  en_curso:   { label: "🔄 En curso",    color: "#3b82f6" },
  cerrado:    { label: "🔒 Cerrado",     color: "#6b7280" },
  rechazado:  { label: "❌ Rechazado",   color: "#e63946" },
};

const nivelRiesgo = {
  bajo:     { label: "🟢 Bajo",     color: "#22c55e", bg: "#dcfce7" },
  medio:    { label: "🟡 Medio",    color: "#d97706", bg: "#fef3c7" },
  alto:     { label: "🔴 Alto",     color: "#e63946", bg: "#fee2e2" },
  critico:  { label: "🚨 Crítico",  color: "#7c2d12", bg: "#fecaca" },
};

function generarCod(prefijo, lista) {
  return `${prefijo}-${new Date().getFullYear()}-${String(lista.length + 1).padStart(3, "0")}`;
}
function fechaHoy() { return new Date().toISOString().slice(0, 10); }

export default function HigieneSeguridad({ onVolver, oscuro, usuario }) {
  const [registros,  setRegistros]  = useState([]);
  const [epps,       setEpps]       = useState([]);
  const [permisos,   setPermisos]   = useState([]);
  const [riesgos,    setRiesgos]    = useState([]);
  const [tabActiva,  setTabActiva]  = useState("registros");
  const [vista,      setVista]      = useState("listado");
  const [detalle,    setDetalle]    = useState(null);
  const [form,       setForm]       = useState({ estado:"abierto", tipo:"incidente", area:"Impresión Offset", fecha:fechaHoy() });
  const [formEPP,    setFormEPP]    = useState({ area:"Impresión Offset", fecha:fechaHoy() });
  const [formPermiso,setFormPermiso]= useState({ tipo:"altura", estado:"pendiente", fecha:fechaHoy() });
  const [formRiesgo, setFormRiesgo] = useState({ area:"Impresión Offset", nivel:"medio" });
  const [filtroEstado,setFiltroEstado]=useState("todos");
  const [modalOC,    setModalOC]    = useState(false);
  const [ariaCargando,setAriaCargando]=useState(false);
  const [ariaRespuesta,setAriaRespuesta]=useState("");
  const [confirmEliminar,setConfirmEliminar]=useState(null);
  const [syncing, setSyncing] = useState(false);

  const bg      = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg  = oscuro ? "#0d2160" : "white";
  const texto   = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde   = oscuro ? "#1e3a8a" : "#eee";
  const navBg   = oscuro ? "#060f30" : "#09184D";
  const subtexto= oscuro ? "#9aabd4" : "#808085";
  const esAdmin = usuario?.rol === "Administrador";

  const inp = { width:"100%", padding:"8px 12px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"13px", boxSizing:"border-box", marginTop:"4px", background:cardBg, color:texto };
  const lbl = { fontSize:"12px", color:subtexto, fontWeight:"600", display:"block", marginTop:"12px" };
  const card= { background:cardBg, borderRadius:"12px", padding:"1.2rem 1.5rem", border:`1px solid ${borde}`, marginBottom:"12px" };

  // ── SYNC ──
  const cargarLocal = useCallback(() => {
    try {
      const data = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
      setRegistros(data.registros || []);
      setEpps(data.epps || []);
      setPermisos(data.permisos || []);
      setRiesgos(data.riesgos || []);
    } catch { }
  }, []);

  const guardarLocal = useCallback((nuevo) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(nuevo));
  }, []);

  const sincronizar = useCallback(async () => {
    setSyncing(true);
    const ok = await bajarDatosSingle(STORAGE_KEY, 'hs_registros');
    if (ok) cargarLocal();
    setSyncing(false);
  }, [cargarLocal]);

  useEffect(() => {
    cargarLocal();
    sincronizar();
  }, [cargarLocal, sincronizar]);

  const guardarRegistros = (lista) => {
    const estado = { registros: lista, epps, permisos, riesgos };
    guardarLocal(estado);
    setRegistros(lista);
    subirDatosSingle(STORAGE_KEY, 'hs_registros');
  };

  const guardarEpps = (lista) => {
    const estado = { registros, epps: lista, permisos, riesgos };
    guardarLocal(estado);
    setEpps(lista);
    subirDatosSingle(STORAGE_KEY, 'hs_registros');
  };

  const guardarPermisos = (lista) => {
    const estado = { registros, epps, permisos: lista, riesgos };
    guardarLocal(estado);
    setPermisos(lista);
    subirDatosSingle(STORAGE_KEY, 'hs_registros');
  };

  const guardarRiesgos = (lista) => {
    const estado = { registros, epps, permisos, riesgos: lista };
    guardarLocal(estado);
    setRiesgos(lista);
    subirDatosSingle(STORAGE_KEY, 'hs_registros');
  };

  // ── KPIs / ÍNDICES SRT ──
  const hoy = new Date();
  const añoActual = hoy.getFullYear();
  const registrosAño = registros.filter(r => new Date(r.fecha).getFullYear() === añoActual);
  const accidentesAño = registrosAño.filter(r => r.tipo === "accidente");
  const totalDiasPerdidos = accidentesAño.reduce((s, r) => s + (parseInt(r.diasPerdidos) || 0), 0);
  const horasTrabajadas = 200000;
  const IF = accidentesAño.length > 0 ? ((accidentesAño.length / horasTrabajadas) * 1000000).toFixed(2) : 0;
  const IG = totalDiasPerdidos > 0 ? ((totalDiasPerdidos / horasTrabajadas) * 1000000).toFixed(2) : 0;
  const diasSinAccidente = (() => {
    const acc = registros.filter(r => r.tipo === "accidente").sort((a,b) => new Date(b.fecha)-new Date(a.fecha));
    if (!acc.length) return "—";
    return Math.floor((hoy - new Date(acc[0].fecha)) / 86400000);
  })();
  const eppsVencidos = epps.filter(e => e.vencimiento && new Date(e.vencimiento) < hoy).length;
  const permisosAbiertos = permisos.filter(p => p.estado === "aprobado" || p.estado === "en_curso").length;
  const riesgosCriticos = riesgos.filter(r => r.nivel === "critico" || r.nivel === "alto").length;

  // ── ARIA ──
  const consultarARIA = async () => {
    setAriaCargando(true);
    setAriaRespuesta("");
    try {
      const resumen = {
        totalRegistros: registros.length,
        accidentesAño,
        IF, IG,
        diasSinAccidente,
        tiposMasFrecuentes: Object.entries(
          registros.reduce((acc, r) => { acc[r.tipo] = (acc[r.tipo]||0)+1; return acc; }, {})
        ).sort((a,b)=>b[1]-a[1]).slice(0,3),
        areasMasFrecuentes: Object.entries(
          registros.reduce((acc, r) => { acc[r.area] = (acc[r.area]||0)+1; return acc; }, {})
        ).sort((a,b)=>b[1]-a[1]).slice(0,3),
        eppsVencidos,
        permisosAbiertos,
        riesgosCriticos,
      };
      const resp = await fetch("/api/aria", {
        method: "POST",
        headers: { ...(await authHeader()), "Content-Type": "application/json", "anthropic-version": "2023-06-01" },
        body: JSON.stringify({
          model: "claude-sonnet-4-5",
          max_tokens: 1200,
          messages: [{
            role: "user",
            content: `Sos un especialista en seguridad e higiene laboral argentina (Ley 19587, Dec 351/79, ISO 45001). Analizá este resumen de H&S de una pyme industrial gráfica y generá un informe ejecutivo con: 1) Diagnóstico del estado actual, 2) Patrones de riesgo detectados, 3) 3 acciones preventivas prioritarias, 4) Recomendación para la dirección. Datos: ${JSON.stringify(resumen)}. Respondé en español, formato claro con títulos.`
          }]
        })
      });
      const data = await resp.json();
      setAriaRespuesta(data.content?.[0]?.text || "Sin respuesta");
    } catch(e) {
      setAriaRespuesta("Error al conectar con ARIA.");
    }
    setAriaCargando(false);
  };

  // ── HEADER ──
  const Header = ({ titulo, onBack, extra }) => (
    <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100, marginBottom:"1.5rem" }}>
      <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
        <button onClick={onBack} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Volver</button>
        <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>{titulo}</span>
        {syncing && <span style={{ fontSize:"11px", color:"#86efac" }}>🔄 Sincronizando...</span>}
      </div>
      {extra}
    </div>
  );

  // ── DETALLE REGISTRO ──
  if (vista === "detalle" && detalle) return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <Header titulo={detalle.codigo} onBack={() => { setDetalle(null); setVista("listado"); }}
        extra={esAdmin && <button onClick={() => setConfirmEliminar(detalle.id)} style={{ background:"rgba(230,57,70,.2)", border:"1px solid rgba(230,57,70,.4)", color:"#e63946", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"12px" }}>🗑 Eliminar</button>}
      />
      <div style={{ padding:"0 1.5rem 2rem", maxWidth:"700px", margin:"0 auto" }}>
        <div style={{ ...card, background: oscuro?"#0a1f5c":"#F0EEFF", border:`1px solid ${oscuro?"#7B5BF2":"#d4c8ff"}` }}>
          {[["Código",detalle.codigo],["Tipo",tiposIncidente[detalle.tipo]?.label],["Área",detalle.area],["Fecha",detalle.fecha],["Hora",detalle.hora],["Persona",detalle.persona],["Testigos",detalle.testigos],["Creado por",detalle.creadoPor]].map(([k,v]) => v && (
            <div key={k} style={{ display:"flex", justifyContent:"space-between", fontSize:"13px", padding:"4px 0", borderBottom:`0.5px solid ${borde}` }}>
              <span style={{ color:subtexto }}>{k}</span>
              <span style={{ color:texto, fontWeight:"500" }}>{v}</span>
            </div>
          ))}
        </div>
        <div style={card}>
          <h3 style={{ fontSize:"13px", fontWeight:"600", color:"#7B5BF2", marginBottom:"10px" }}>Estado</h3>
          <div style={{ display:"flex", gap:"8px", flexWrap:"wrap" }}>
            {Object.entries(estadosHS).map(([val,{label,color}]) => (
              <button key={val} onClick={() => { if(!esAdmin) return; const act = registros.map(r => r.id===detalle.id?{...r,estado:val}:r); guardarRegistros(act); setDetalle(d=>({...d,estado:val})); }}
                style={{ padding:"7px 12px", borderRadius:"10px", fontSize:"12px", cursor:esAdmin?"pointer":"default", fontWeight:"600", border:detalle.estado===val?`2px solid ${color}`:`1px solid ${borde}`, background:detalle.estado===val?`${color}22`:cardBg, color:detalle.estado===val?color:subtexto }}>
                {label}
              </button>
            ))}
          </div>
        </div>
        {[["Descripción",detalle.descripcion],["Causa inmediata",detalle.causaInmediata],["Causa raíz",detalle.causaRaiz],["Acción correctiva",detalle.accionCorrectiva],["Medidas preventivas",detalle.medidasPreventivas],["EPI utilizados",detalle.epi],["Lesiones / Daños",detalle.lesiones],["Días perdidos",detalle.diasPerdidos]].map(([label,val]) => val && (
          <div key={label} style={card}>
            <h3 style={{ fontSize:"12px", fontWeight:"600", color:subtexto, marginBottom:"6px" }}>{label}</h3>
            <p style={{ fontSize:"13px", color:texto, lineHeight:"1.6", margin:0 }}>{val}</p>
          </div>
        ))}
      </div>
    </div>
  );

  // ── FORM NUEVO REGISTRO ──
  if (vista === "nuevo_registro") return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <Header titulo="Nuevo Registro H&S" onBack={() => setVista("listado")} />
      <div style={{ padding:"0 1.5rem 2rem", maxWidth:"700px", margin:"0 auto" }}>
        <div style={card}>
          <span style={lbl}>Tipo de evento</span>
          <div style={{ display:"flex", gap:"6px", flexWrap:"wrap", marginTop:"6px" }}>
            {Object.entries(tiposIncidente).map(([val,{label,color}]) => (
              <button key={val} onClick={() => setForm(f=>({...f,tipo:val}))}
                style={{ padding:"6px 10px", borderRadius:"8px", fontSize:"11px", cursor:"pointer", fontWeight:"600", border:form.tipo===val?`2px solid ${color}`:`1px solid ${borde}`, background:form.tipo===val?`${color}22`:cardBg, color:form.tipo===val?color:texto }}>
                {label}
              </button>
            ))}
          </div>
          <span style={lbl}>Área</span>
          <select onChange={e=>setForm(f=>({...f,area:e.target.value}))} style={inp} value={form.area}>
            {areasPlanta.map(a=><option key={a}>{a}</option>)}
          </select>
          <span style={lbl}>Estado inicial</span>
          <div style={{ display:"flex", gap:"8px", marginTop:"6px", flexWrap:"wrap" }}>
            {Object.entries(estadosHS).map(([val,{label,color}]) => (
              <button key={val} onClick={() => setForm(f=>({...f,estado:val}))}
                style={{ padding:"7px 12px", borderRadius:"10px", fontSize:"12px", cursor:"pointer", fontWeight:"600", border:form.estado===val?`2px solid ${color}`:`1px solid ${borde}`, background:form.estado===val?`${color}22`:cardBg, color:form.estado===val?color:texto }}>
                {label}
              </button>
            ))}
          </div>
          {[{k:"fecha",label:"Fecha",type:"date"},{k:"hora",label:"Hora",type:"time"},{k:"persona",label:"Persona involucrada"},{k:"testigos",label:"Testigos"},{k:"descripcion",label:"Descripción del hecho",multi:true},{k:"causaInmediata",label:"Causa inmediata",multi:true},{k:"causaRaiz",label:"Causa raíz",multi:true},{k:"lesiones",label:"Lesiones o daños"},{k:"diasPerdidos",label:"Días perdidos"},{k:"epi",label:"EPI utilizados"},{k:"accionCorrectiva",label:"Acción correctiva",multi:true},{k:"medidasPreventivas",label:"Medidas preventivas",multi:true}].map(({k,label,type,multi})=>(
            <div key={k}>
              <span style={lbl}>{label}</span>
              {multi
                ? <textarea rows={3} value={form[k]||""} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))} style={{...inp,resize:"none"}}/>
                : <input type={type||"text"} value={form[k]||""} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))} style={inp}/>
              }
            </div>
          ))}
          <button onClick={() => { const nuevo={...form,id:Date.now(),codigo:generarCod("HS",registros),fechaCreacion:new Date().toISOString(),creadoPor:usuario?.nombre||"Sistema"}; guardarRegistros([...registros,nuevo]); setForm({estado:"abierto",tipo:"incidente",area:"Impresión Offset",fecha:fechaHoy()}); setVista("listado"); }}
            style={{ width:"100%", padding:"13px", background:"#7B5BF2", color:"white", border:"none", borderRadius:"10px", fontSize:"14px", fontWeight:"600", cursor:"pointer", marginTop:"1.5rem" }}>
            Guardar Registro
          </button>
        </div>
      </div>
    </div>
  );

  // ── FORM NUEVO EPP ──
  if (vista === "nuevo_epp") return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <Header titulo="Registrar EPP" onBack={() => setVista("listado")} />
      <div style={{ padding:"0 1.5rem 2rem", maxWidth:"700px", margin:"0 auto" }}>
        <div style={card}>
          {[{k:"empleado",label:"Empleado"},{k:"legajo",label:"Legajo / ID"},{k:"area",label:"Área",select:areasPlanta},{k:"tipo",label:"Tipo de EPP",select:tiposEPP},{k:"marca",label:"Marca / Modelo"},{k:"fechaEntrega",label:"Fecha de entrega",type:"date"},{k:"vencimiento",label:"Fecha de vencimiento",type:"date"},{k:"observaciones",label:"Observaciones",multi:true}].map(({k,label,type,select,multi})=>(
            <div key={k}>
              <span style={lbl}>{label}</span>
              {select
                ? <select value={formEPP[k]||""} onChange={e=>setFormEPP(f=>({...f,[k]:e.target.value}))} style={inp}>
                    <option value="">Seleccionar...</option>
                    {select.map(o=><option key={o}>{o}</option>)}
                  </select>
                : multi
                  ? <textarea rows={2} value={formEPP[k]||""} onChange={e=>setFormEPP(f=>({...f,[k]:e.target.value}))} style={{...inp,resize:"none"}}/>
                  : <input type={type||"text"} value={formEPP[k]||""} onChange={e=>setFormEPP(f=>({...f,[k]:e.target.value}))} style={inp}/>
              }
            </div>
          ))}
          <button onClick={() => { const nuevo={...formEPP,id:Date.now(),codigo:generarCod("EPP",epps),creadoPor:usuario?.nombre||"Sistema"}; guardarEpps([...epps,nuevo]); setFormEPP({area:"Impresión Offset",fechaEntrega:fechaHoy()}); setVista("listado"); }}
            style={{ width:"100%", padding:"13px", background:"#22c55e", color:"white", border:"none", borderRadius:"10px", fontSize:"14px", fontWeight:"600", cursor:"pointer", marginTop:"1.5rem" }}>
            Registrar EPP
          </button>
        </div>
      </div>
    </div>
  );

  // ── FORM PERMISO ──
  if (vista === "nuevo_permiso") return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <Header titulo="Nuevo Permiso de Trabajo" onBack={() => setVista("listado")} />
      <div style={{ padding:"0 1.5rem 2rem", maxWidth:"700px", margin:"0 auto" }}>
        <div style={card}>
          <span style={lbl}>Tipo de trabajo</span>
          <div style={{ display:"flex", gap:"6px", flexWrap:"wrap", marginTop:"6px" }}>
            {Object.entries(tiposPermiso).map(([val,{label,color}])=>(
              <button key={val} onClick={()=>setFormPermiso(f=>({...f,tipo:val}))}
                style={{ padding:"6px 10px", borderRadius:"8px", fontSize:"11px", cursor:"pointer", fontWeight:"600", border:formPermiso.tipo===val?`2px solid ${color}`:`1px solid ${borde}`, background:formPermiso.tipo===val?`${color}22`:cardBg, color:formPermiso.tipo===val?color:texto }}>
                {label}
              </button>
            ))}
          </div>
          {[{k:"descripcion",label:"Descripción del trabajo",multi:true},{k:"solicitante",label:"Solicitante"},{k:"responsable",label:"Responsable H&S"},{k:"fecha",label:"Fecha",type:"date"},{k:"horaInicio",label:"Hora inicio",type:"time"},{k:"horaFin",label:"Hora fin",type:"time"},{k:"area",label:"Área",select:areasPlanta},{k:"epiRequerido",label:"EPI requerido",multi:true},{k:"medidasSeguridad",label:"Medidas de seguridad",multi:true}].map(({k,label,type,select,multi})=>(
            <div key={k}>
              <span style={lbl}>{label}</span>
              {select
                ? <select value={formPermiso[k]||""} onChange={e=>setFormPermiso(f=>({...f,[k]:e.target.value}))} style={inp}>
                    {select.map(o=><option key={o}>{o}</option>)}
                  </select>
                : multi
                  ? <textarea rows={2} value={formPermiso[k]||""} onChange={e=>setFormPermiso(f=>({...f,[k]:e.target.value}))} style={{...inp,resize:"none"}}/>
                  : <input type={type||"text"} value={formPermiso[k]||""} onChange={e=>setFormPermiso(f=>({...f,[k]:e.target.value}))} style={inp}/>
              }
            </div>
          ))}
          <button onClick={() => { const nuevo={...formPermiso,id:Date.now(),codigo:generarCod("PT",permisos),estado:"pendiente",creadoPor:usuario?.nombre||"Sistema",fechaCreacion:new Date().toISOString()}; guardarPermisos([...permisos,nuevo]); setFormPermiso({tipo:"altura",estado:"pendiente",fecha:fechaHoy()}); setVista("listado"); }}
            style={{ width:"100%", padding:"13px", background:"#f97316", color:"white", border:"none", borderRadius:"10px", fontSize:"14px", fontWeight:"600", cursor:"pointer", marginTop:"1.5rem" }}>
            Emitir Permiso
          </button>
        </div>
      </div>
    </div>
  );

  // ── FORM RIESGO ──
  if (vista === "nuevo_riesgo") return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <Header titulo="Nuevo Riesgo" onBack={() => setVista("listado")} />
      <div style={{ padding:"0 1.5rem 2rem", maxWidth:"700px", margin:"0 auto" }}>
        <div style={card}>
          {[{k:"area",label:"Área",select:areasPlanta},{k:"puesto",label:"Puesto / Tarea"},{k:"peligro",label:"Peligro identificado",multi:true},{k:"consecuencia",label:"Consecuencia potencial",multi:true},{k:"nivel",label:"Nivel de riesgo",select:Object.keys(nivelRiesgo)},{k:"probabilidad",label:"Probabilidad (1-5)"},{k:"severidad",label:"Severidad (1-5)"},{k:"controlExistente",label:"Control existente",multi:true},{k:"accionPropuesta",label:"Acción propuesta",multi:true},{k:"responsable",label:"Responsable"},{k:"fechaLimite",label:"Fecha límite",type:"date"}].map(({k,label,type,select,multi})=>(
            <div key={k}>
              <span style={lbl}>{label}</span>
              {select
                ? <select value={formRiesgo[k]||""} onChange={e=>setFormRiesgo(f=>({...f,[k]:e.target.value}))} style={inp}>
                    {select.map(o=><option key={o}>{o}</option>)}
                  </select>
                : multi
                  ? <textarea rows={2} value={formRiesgo[k]||""} onChange={e=>setFormRiesgo(f=>({...f,[k]:e.target.value}))} style={{...inp,resize:"none"}}/>
                  : <input type={type||"text"} value={formRiesgo[k]||""} onChange={e=>setFormRiesgo(f=>({...f,[k]:e.target.value}))} style={inp}/>
              }
            </div>
          ))}
          <button onClick={() => { const npr=(parseInt(formRiesgo.probabilidad)||1)*(parseInt(formRiesgo.severidad)||1); const nuevo={...formRiesgo,id:Date.now(),codigo:generarCod("RZ",riesgos),npr,creadoPor:usuario?.nombre||"Sistema",fechaCreacion:new Date().toISOString()}; guardarRiesgos([...riesgos,nuevo]); setFormRiesgo({area:"Impresión Offset",nivel:"medio"}); setVista("listado"); }}
            style={{ width:"100%", padding:"13px", background:"#e63946", color:"white", border:"none", borderRadius:"10px", fontSize:"14px", fontWeight:"600", cursor:"pointer", marginTop:"1.5rem" }}>
            Registrar Riesgo
          </button>
        </div>
      </div>
    </div>
  );

  // ── LISTADO PRINCIPAL ──
  return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      {confirmEliminar && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:200, display:"flex", alignItems:"center", justifyContent:"center" }}>
          <div style={{ background:cardBg, borderRadius:"16px", padding:"2rem", maxWidth:"340px", width:"90%", textAlign:"center" }}>
            <p style={{ fontSize:"32px" }}>🗑️</p>
            <p style={{ fontSize:"15px", fontWeight:"600", color:texto, margin:"1rem 0 .5rem" }}>¿Eliminar este registro?</p>
            <p style={{ fontSize:"12px", color:subtexto, marginBottom:"1.5rem" }}>Esta acción no se puede deshacer.</p>
            <div style={{ display:"flex", gap:"10px", justifyContent:"center" }}>
              <button onClick={()=>setConfirmEliminar(null)} style={{ padding:"9px 18px", background:"none", border:`1px solid ${borde}`, borderRadius:"10px", cursor:"pointer", color:texto, fontSize:"13px" }}>Cancelar</button>
              <button onClick={()=>{ guardarRegistros(registros.filter(r=>r.id!==confirmEliminar)); setConfirmEliminar(null); setDetalle(null); setVista("listado"); }} style={{ padding:"9px 18px", background:"#e63946", border:"none", borderRadius:"10px", cursor:"pointer", color:"white", fontSize:"13px", fontWeight:"600" }}>Eliminar</button>
            </div>
          </div>
        </div>
      )}

      {/* NAV */}
      <div style={{ background:navBg, padding:"1rem 1.5rem", position:"sticky", top:0, zIndex:100 }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"10px" }}>
          <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
            <button onClick={onVolver} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Menú</button>
            <BotonInstructivo moduloKey="hs" oscuro={true} />
            {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="hs" oscuro={oscuro} />}
            <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>🦺 Higiene y Seguridad</span>
            {syncing && <span style={{ fontSize:"10px", color:"#86efac" }}>🔄</span>}
          </div>
          <div style={{ display:"flex", gap:"8px" }}>
            <button onClick={()=>setModalOC(true)} style={{ padding:"6px 12px", background:"rgba(255,255,255,0.1)", border:"1px solid rgba(255,255,255,0.3)", color:"white", borderRadius:"8px", cursor:"pointer", fontSize:"12px" }}>🦺 Generar OC EPP</button>
            {modalOC && <ModalGenerarOC oscuro={oscuro} usuario={usuario} origen="HyS" categoriaDefault="EPP / Seguridad" onClose={()=>setModalOC(false)} onCreada={(cod)=>{ alert(`✅ OC generada: ${cod}`); setModalOC(false); }}/>}
          </div>
        </div>
        <div style={{ display:"flex", gap:"6px", overflowX:"auto" }}>
          {TABS_PRINCIPALES.map(t=>(
            <button key={t} onClick={()=>{ setTabActiva(t); setVista("listado"); }}
              style={{ padding:"5px 12px", borderRadius:"20px", fontSize:"11px", cursor:"pointer", fontWeight:"600", whiteSpace:"nowrap", border:tabActiva===t?"2px solid #7B5BF2":"1px solid rgba(255,255,255,0.2)", background:tabActiva===t?"rgba(123,91,242,0.3)":"rgba(255,255,255,0.07)", color:tabActiva===t?"white":"rgba(255,255,255,0.7)" }}>
              {TABS_LABELS[t]}
            </button>
          ))}
        </div>
      </div>

      <div style={{ padding:"1rem 1.5rem" }}>

        {/* KPIs GLOBALES */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))", gap:"10px", marginBottom:"1.5rem" }}>
          {[
            ["Días sin accidente", diasSinAccidente, "#22c55e"],
            ["Registros totales",  registros.length, "#7B5BF2"],
            ["IF (×10⁶hs)",        IF,               "#3b82f6"],
            ["IG (×10⁶hs)",        IG,               "#f97316"],
            ["EPP vencidos",       eppsVencidos,     eppsVencidos>0?"#e63946":"#22c55e"],
            ["Permisos activos",   permisosAbiertos, "#f59e0b"],
            ["Riesgos altos",      riesgosCriticos,  riesgosCriticos>0?"#e63946":"#22c55e"],
          ].map(([lab,val,col])=>(
            <div key={lab} style={{ background:cardBg, borderRadius:"12px", padding:"1rem", border:`1px solid ${borde}`, textAlign:"center" }}>
              <p style={{ fontSize:"20px", fontWeight:"700", color:col, margin:0 }}>{val}</p>
              <p style={{ fontSize:"10px", color:subtexto, margin:"4px 0 0", lineHeight:"1.3" }}>{lab}</p>
            </div>
          ))}
        </div>

        {/* ── TAB REGISTROS ── */}
        {tabActiva==="registros" && (
          <>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"10px" }}>
              <div style={{ display:"flex", gap:"6px", flexWrap:"wrap" }}>
                <button onClick={()=>setFiltroEstado("todos")} style={{ padding:"4px 10px", borderRadius:"16px", fontSize:"11px", cursor:"pointer", fontWeight:"600", border:filtroEstado==="todos"?"2px solid #7B5BF2":`1px solid ${borde}`, background:filtroEstado==="todos"?"rgba(123,91,242,.1)":cardBg, color:filtroEstado==="todos"?"#7B5BF2":subtexto }}>Todos</button>
                {Object.entries(estadosHS).map(([val,{label,color}])=>(
                  <button key={val} onClick={()=>setFiltroEstado(val)} style={{ padding:"4px 10px", borderRadius:"16px", fontSize:"11px", cursor:"pointer", fontWeight:"600", border:filtroEstado===val?`2px solid ${color}`:`1px solid ${borde}`, background:filtroEstado===val?`${color}22`:cardBg, color:filtroEstado===val?color:subtexto }}>{label}</button>
                ))}
              </div>
              {esAdmin && <button onClick={()=>setVista("nuevo_registro")} style={{ padding:"7px 14px", background:"#e63946", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>+ Nuevo</button>}
            </div>
            {registros.filter(r=>filtroEstado==="todos"||r.estado===filtroEstado).length===0
              ? <div style={{ textAlign:"center", padding:"4rem" }}><p style={{ fontSize:"36px" }}>🦺</p><p style={{ color:subtexto, marginTop:"8px" }}>Sin registros</p></div>
              : registros.filter(r=>filtroEstado==="todos"||r.estado===filtroEstado).map(r=>(
                <div key={r.id} onClick={()=>{ setDetalle(r); setVista("detalle"); }} style={{ ...card, cursor:"pointer" }}
                  onMouseEnter={e=>e.currentTarget.style.boxShadow="0 4px 16px rgba(123,91,242,0.15)"}
                  onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}>
                  <div style={{ display:"flex", justifyContent:"space-between" }}>
                    <div>
                      <span style={{ fontWeight:"700", color:tiposIncidente[r.tipo]?.color, fontSize:"12px" }}>{tiposIncidente[r.tipo]?.label}</span>
                      <span style={{ marginLeft:"8px", fontSize:"12px", color:"#7B5BF2", fontWeight:"600" }}>{r.codigo}</span>
                      <p style={{ fontSize:"12px", color:texto, margin:"4px 0 2px" }}>{r.descripcion?.slice(0,80)||"Sin descripción"}{r.descripcion?.length>80?"...":""}</p>
                      <p style={{ fontSize:"11px", color:subtexto }}>{r.area} · {r.fecha} · {r.creadoPor}</p>
                    </div>
                    <span style={{ fontSize:"11px", fontWeight:"700", color:estadosHS[r.estado]?.color, whiteSpace:"nowrap" }}>{estadosHS[r.estado]?.label}</span>
                  </div>
                </div>
              ))
            }
          </>
        )}

        {/* ── TAB EPP ── */}
        {tabActiva==="epp" && (
          <>
            <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:"10px" }}>
              {esAdmin && <button onClick={()=>setVista("nuevo_epp")} style={{ padding:"7px 14px", background:"#22c55e", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>+ Registrar EPP</button>}
            </div>
            {epps.length===0
              ? <div style={{ textAlign:"center", padding:"4rem" }}><p style={{ fontSize:"36px" }}>🦺</p><p style={{ color:subtexto, marginTop:"8px" }}>Sin EPP registrados</p></div>
              : epps.map(e=>{
                  const vencido = e.vencimiento && new Date(e.vencimiento) < hoy;
                  const proxVencer = e.vencimiento && !vencido && (new Date(e.vencimiento)-hoy) < 30*86400000;
                  return (
                    <div key={e.id} style={{ ...card, borderLeft:`4px solid ${vencido?"#e63946":proxVencer?"#f59e0b":"#22c55e"}` }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                        <div>
                          <span style={{ fontWeight:"700", color:texto, fontSize:"13px" }}>{e.tipo}</span>
                          <span style={{ marginLeft:"8px", fontSize:"11px", color:"#7B5BF2" }}>{e.codigo}</span>
                          <p style={{ fontSize:"12px", color:subtexto, marginTop:"3px" }}>👤 {e.empleado} · {e.area}</p>
                          <p style={{ fontSize:"11px", color:subtexto }}>Entrega: {e.fechaEntrega} · Vence: {e.vencimiento||"—"}</p>
                        </div>
                        <span style={{ fontSize:"10px", fontWeight:"700", color:vencido?"#e63946":proxVencer?"#f59e0b":"#22c55e", background:vencido?"#fee2e2":proxVencer?"#fef3c7":"#dcfce7", padding:"3px 8px", borderRadius:"6px" }}>
                          {vencido?"VENCIDO":proxVencer?"PRÓXIMO":"VIGENTE"}
                        </span>
                      </div>
                    </div>
                  );
                })
            }
          </>
        )}

        {/* ── TAB PERMISOS ── */}
        {tabActiva==="permisos" && (
          <>
            <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:"10px" }}>
              {esAdmin && <button onClick={()=>setVista("nuevo_permiso")} style={{ padding:"7px 14px", background:"#f97316", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>+ Emitir Permiso</button>}
            </div>
            {permisos.length===0
              ? <div style={{ textAlign:"center", padding:"4rem" }}><p style={{ fontSize:"36px" }}>🔑</p><p style={{ color:subtexto, marginTop:"8px" }}>Sin permisos de trabajo</p></div>
              : permisos.map(p=>(
                <div key={p.id} style={card}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                    <div>
                      <span style={{ fontWeight:"700", color:tiposPermiso[p.tipo]?.color, fontSize:"13px" }}>{tiposPermiso[p.tipo]?.label}</span>
                      <span style={{ marginLeft:"8px", fontSize:"11px", color:"#7B5BF2" }}>{p.codigo}</span>
                      <p style={{ fontSize:"12px", color:texto, marginTop:"3px" }}>{p.descripcion?.slice(0,70)||"Sin descripción"}</p>
                      <p style={{ fontSize:"11px", color:subtexto }}>{p.area} · {p.fecha} · {p.solicitante}</p>
                    </div>
                    <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:"4px" }}>
                      <span style={{ fontSize:"10px", fontWeight:"700", color:estadosPermiso[p.estado]?.color }}>{estadosPermiso[p.estado]?.label}</span>
                      {esAdmin && p.estado==="pendiente" && (
                        <button onClick={()=>{ const act=permisos.map(x=>x.id===p.id?{...x,estado:"aprobado",aprobadoPor:usuario?.nombre}:x); guardarPermisos(act); }}
                          style={{ fontSize:"10px", padding:"3px 8px", background:"#22c55e", color:"white", border:"none", borderRadius:"6px", cursor:"pointer" }}>Aprobar</button>
                      )}
                    </div>
                  </div>
                </div>
              ))
            }
          </>
        )}

        {/* ── TAB MATRIZ ── */}
        {tabActiva==="matriz" && (
          <>
            <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:"10px" }}>
              {esAdmin && <button onClick={()=>setVista("nuevo_riesgo")} style={{ padding:"7px 14px", background:"#e63946", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>+ Nuevo Riesgo</button>}
            </div>
            {riesgos.length===0
              ? <div style={{ textAlign:"center", padding:"4rem" }}><p style={{ fontSize:"36px" }}>📊</p><p style={{ color:subtexto, marginTop:"8px" }}>Sin riesgos registrados</p></div>
              : riesgos.sort((a,b)=>(b.npr||0)-(a.npr||0)).map(r=>(
                <div key={r.id} style={{ ...card, borderLeft:`4px solid ${nivelRiesgo[r.nivel]?.color||"#7B5BF2"}` }}>
                  <div style={{ display:"flex", justifyContent:"space-between" }}>
                    <div>
                      <span style={{ fontWeight:"700", color:texto, fontSize:"13px" }}>{r.peligro?.slice(0,60)||"Sin descripción"}</span>
                      <span style={{ marginLeft:"8px", fontSize:"11px", color:"#7B5BF2" }}>{r.codigo}</span>
                      <p style={{ fontSize:"12px", color:subtexto, marginTop:"3px" }}>{r.area} · {r.puesto}</p>
                      <p style={{ fontSize:"11px", color:subtexto }}>NPR: {r.npr||"—"} · Responsable: {r.responsable||"—"} · Límite: {r.fechaLimite||"—"}</p>
                    </div>
                    <span style={{ fontSize:"10px", fontWeight:"700", color:nivelRiesgo[r.nivel]?.color, background:nivelRiesgo[r.nivel]?.bg, padding:"3px 8px", borderRadius:"6px", whiteSpace:"nowrap" }}>
                      {nivelRiesgo[r.nivel]?.label}
                    </span>
                  </div>
                </div>
              ))
            }
          </>
        )}

        {/* ── TAB ÍNDICES SRT ── */}
        {tabActiva==="indices" && (
          <div style={{ maxWidth:"600px", margin:"0 auto" }}>
            <div style={{ ...card, background: oscuro?"#0a1f5c":"#F0EEFF", border:`1px solid ${oscuro?"#7B5BF2":"#d4c8ff"}` }}>
              <h3 style={{ fontSize:"13px", fontWeight:"600", color:"#7B5BF2", marginBottom:"12px" }}>Base de cálculo</h3>
              <p style={{ fontSize:"12px", color:subtexto }}>Horas trabajadas estimadas: <strong style={{color:texto}}>200.000 hs/año</strong></p>
              <p style={{ fontSize:"11px", color:subtexto, marginTop:"4px" }}>Modificable próxima versión · Accidentes año {añoActual}: {accidentesAño.length} · Días perdidos: {totalDiasPerdidos}</p>
            </div>
            {[
              ["📊 Índice de Frecuencia (IF)", IF, "Accidentes × 10⁶ / horas trabajadas", "#3b82f6", IF>5?"⚠️ Alto":"✅ Normal"],
              ["📉 Índice de Gravedad (IG)", IG, "Días perdidos × 10⁶ / horas trabajadas", "#f97316", IG>100?"⚠️ Alto":"✅ Normal"],
              ["📅 Días sin accidente", diasSinAccidente, "Desde el último accidente registrado", "#22c55e", diasSinAccidente>30?"✅ Excelente":"⚠️ Revisar"],
              ["🦺 EPP vencidos", eppsVencidos, "EPP con fecha de vencimiento superada", eppsVencidos>0?"#e63946":"#22c55e", eppsVencidos>0?"⚠️ Requiere acción":"✅ Al día"],
            ].map(([titulo,valor,desc,color,estado])=>(
              <div key={titulo} style={card}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <div>
                    <p style={{ fontSize:"13px", fontWeight:"600", color:texto, margin:"0 0 4px" }}>{titulo}</p>
                    <p style={{ fontSize:"11px", color:subtexto, margin:0 }}>{desc}</p>
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <p style={{ fontSize:"22px", fontWeight:"700", color, margin:0 }}>{valor}</p>
                    <p style={{ fontSize:"10px", color:subtexto, margin:0 }}>{estado}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ── TAB ARIA ── */}
        {tabActiva==="aria" && (
          <div style={{ maxWidth:"700px", margin:"0 auto" }}>
            <div style={{ ...card, background: oscuro?"#0a1f5c":"#F0EEFF", border:`1px solid ${oscuro?"#7B5BF2":"#d4c8ff"}` }}>
              <h3 style={{ fontSize:"14px", fontWeight:"700", color:"#7B5BF2", marginBottom:"6px" }}>🤖 ARIA — Análisis H&S</h3>
              <p style={{ fontSize:"12px", color:subtexto, marginBottom:"12px" }}>ARIA analiza todos los registros, EPP, permisos y riesgos para generar un diagnóstico ejecutivo con recomendaciones basadas en Ley 19587, Dec 351/79 e ISO 45001.</p>
              <button onClick={consultarARIA} disabled={ariaCargando}
                style={{ padding:"10px 20px", background:ariaCargando?"#9ca3af":"#7B5BF2", color:"white", border:"none", borderRadius:"10px", cursor:ariaCargando?"not-allowed":"pointer", fontSize:"13px", fontWeight:"600" }}>
                {ariaCargando?"Analizando...":"Generar informe ejecutivo"}
              </button>
            </div>
            {ariaRespuesta && (
              <div style={card}>
                <h3 style={{ fontSize:"13px", fontWeight:"600", color:"#7B5BF2", marginBottom:"10px" }}>Informe ARIA</h3>
                <pre style={{ fontSize:"12px", color:texto, lineHeight:"1.7", whiteSpace:"pre-wrap", fontFamily:"sans-serif", margin:0 }}>{ariaRespuesta}</pre>
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
}
